import React from 'react'

export const getBookListColumns = (getStudentBookData, getIsReadStatus, ChangeStatus, isProfile = false, isInstructorView = false) => {
	// Profile view: show only title and author
	if (isProfile) {
		return [
			{
				name: 'Title',
				selector: (row) => row.title,
				sortable: true,
				width: '60%'
			},
			{
				name: 'Author',
				selector: (row) => row.author,
				sortable: true,
				width: '40%'
			}
		]
	}

	// Full view: show all columns
	return [
		{
			name: 'Id',
			selector: (row) => row.bookId,
			sortable: true,
			width: '10%'
		},
		{
			name: 'Title',
			selector: (row) => row.title,
			sortable: true,
			width: '40%'
		},
		{
			name: 'Author',
			selector: (row) => row.author,
			sortable: true,
			width: '30%'
		},
		{
			name: 'Status',
			width: '20%',
			center: true,
			cell: (row) => {
				const isRead = getIsReadStatus(row.bookId)

				if (isInstructorView) {
					return (
						<span className={`badge ${isRead ? 'bg-success' : 'bg-secondary'}`} style={{ minWidth: '80px' }}>
							{isRead ? 'Read' : 'Not Yet'}
						</span>
					)
				}

				return (
					<div className="form-check form-switch check-on">
						<input
							className="form-check-input"
							type="checkbox"
							checked={isRead}
							onChange={() => ChangeStatus(getStudentBookData(row.bookId), isRead, row.bookId)}
						/>
					</div>
				)
			},
			ignoreRowClick: true
		}
	]
}
